import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import AccountBoxIcon from "@material-ui/icons/AccountBox";

import CardTable from "components/CardTable/CardTable.jsx";
import { ModalV2 } from "components/Modal/ModalV2";
import Snackbar from "components/Snackbar/Snackbar";

import { columns } from "./columns";
import { CreditCustomerInputs } from "./CreditCustomerInputs";
import { CustomerForm } from "./accounts/CustomerForm";
import { CustomerSearchInput } from "./CustomerSearchInput";
import { FormVerifyService } from "./FormVerifyService";

import { CUSTOMERS_TYPES } from "redux/reducers/customers/customersTypes";
import {
  cleanCustomers,
  getCustomers,
  resetCustomer,
  setStationsAvailable,
} from "redux/actions/customers/customersAction";
import { clearSnackbar } from "redux/actions/search/searchActions";

import { customersTypeSearch } from "helpers/dictionary";
import { decodeToken } from "helpers/decodeToken";
import { logMessageToService } from "helpers/errors";
import { getPersistLocalStorage } from "helpers/localstorageTool";

import { useForm } from "hooks/useForm.js";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { useValidateReload } from "hooks/useValidateReload";

// import AuthenticatorComponentDefaults from "@aws-amplify/ui-react-core";
const tableKey = "customersTable";

export const CustomersTable = () => {
  const loadings = [
    "loadingCustomerCrud",
    "loadingUpdateCredit",
    "loadingCreateOrder",
    "loadingCreditAccount",
    "loadingCustomerNavigation",
  ];
  useValidateReload(loadings);

  const { restoreTable, setSnackbar } = useSearch({
    tableKey,
  });
  const agentCall = getPersistLocalStorage("contact-global");
  const { id } = useParams();
  const dispatch = useDispatch();
  const { isOpen, message, color, isLoadingComp } = useSelector(
    ({ search }) => search,
  );
  const { stationsList } = useSelector(({ companies }) => companies);
  const { allAccounts, customers, stopLoad, accountInput } = useSelector(
    ({ customersReducer }) => customersReducer,
  );
  const { rules } = useSelector(({ login }) => login);
  const [mapAccounts, setMapAccounts] = useState(allAccounts);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    cleanForm,
  } = useForm({
    searchCustomers: accountInput,
    postalCode: "",
    searchWholesales: "",
    searchType: customersTypeSearch[0],
  });
  const [openAvailable, setOpenAvailable] = useToggle();
  const [open, setOpen] = useToggle();
  const [agentState, setAgentState] = useState({});
  const [creditFilter, setCreditFilter] = useState({
    active: true,
    suspended: true,
  });
  const [customersCredit, setCustomersCredit] = useState({
    active: 0,
    suspended: 0,
  });
  const { searchCustomers, searchWholesales, searchType } = inputValues;

  const handleSwitches = (name) =>
    setCreditFilter({ ...creditFilter, [name]: !creditFilter[name] });

  const handleCloseSnackbar = () => {
    dispatch(clearSnackbar());
  };

  const handleClean = () => {
    handleNewValues({
      searchCustomers: "",
      searchWholesales: "",
    });
    dispatch(cleanCustomers());
    restoreTable(tableKey);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchCustomers.length === 0) {
      setSnackbar(
        "Por favor, introduce un nombre o número de teléfono.",
        "warning",
      );
      return;
    }
    if (searchCustomers.length < 3 || searchCustomers.length > 250) {
      setSnackbar(
        "El el nombre debe de tener una logitud minima de 4 caracteres",
        "warning",
      );
      return;
    }
    setCreditFilter({
      active: true,
      suspended: true,
    });
    setCustomersCredit({
      active: 0,
      suspended: 0,
    });
    restoreTable(tableKey);
    dispatch(getCustomers(searchCustomers, searchType?.value, stationsList));
  };

  const handleOpenAvailable = () => {
    handleCloseSnackbar();
    setOpenAvailable();
  };

  useEffect(() => {
    if (!id && !agentCall) {
      dispatch({
        type: CUSTOMERS_TYPES.NEW_CUSTOMER_MODE,
        payload: true,
      });
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (agentCall?.phone) {
      setAgentState(agentCall);
      const token = decodeToken(agentCall?.token);
      if (token) {
        dispatch(setStationsAvailable(stationsList));
      } else {
        logMessageToService(`agentCall no Token:
          ${JSON.stringify(agentCall, null, 2)}`)
      }
    }
    //eslint-disable-next-line
  }, [agentCall?.phone]);

  useEffect(() => {
    if (agentState?.phone && !stopLoad) {
      const isNewCall = accountInput !== agentState?.phone;
      const noData = customers.length === 0 && allAccounts.length === 0;
      
      if (noData || isNewCall) {
        dispatch(getCustomers(agentState?.phone));
        handleNewValues({
          searchCustomers: agentState?.phone,
        });
      }
      return;
    }
    
    // Solo resetear si no hay agente Y no hay modales abiertos
    if (!agentState && !openAvailable && !open) {
      dispatch(resetCustomer());
    }
  }, [agentState?.phone, stopLoad, openAvailable, open]);

  useEffect(() => {
    let active = 0;
    let suspended = 0;
    allAccounts.forEach((account) => {
      const customer = customers.find(
        (customer) => customer.id === account.idCustomer,
      );
      if (customer?.isCredit && !customer.isCreditSuspended) active++;
      if (customer?.isCreditSuspended) suspended++;
    });
    setCustomersCredit({ active, suspended });
    setMapAccounts(allAccounts);
    //eslint-disable-next-line
  }, [allAccounts]);

  useEffect(() => {
    if (customersCredit.active || customersCredit.suspended)
      setMapAccounts(
        allAccounts.filter((account) => {
          const customer = customers.find(
            (customer) => customer.id === account.idCustomer,
          );
          let resp = true;
          if (
            !creditFilter.active &&
            customer.isCredit &&
            !customer.isCreditSuspended
          )
            resp = false;
          if (!creditFilter.suspended && customer.isCreditSuspended)
            resp = false;
          return resp;
        }),
      );
    //eslint-disable-next-line
  }, [creditFilter]);

  return (
    <>
      <CardTable
        columns={columns}
        data={mapAccounts}
        isLoading={isLoadingComp?.loadingCustomers}
        hasControl
        hasHeader
        icon={<AccountBoxIcon />}
        title="Busqueda de Cuentas"
        titleBlock
        blockBtn
        tableKey={tableKey}
        rowStyle={false}
        tableContent={
          <CreditCustomerInputs
            values={{
              creditFilter,
              customersCredit,
              handleSwitches,
            }}
          />
        }
        controlProps={{
          flexGrow: 1,
          justifyContent: "flex-end",
        }}
        controls={
          <CustomerSearchInput
            values={{
              searchCustomers,
              handleInputOnChange,
              handleSearch,
              cleanForm,
              searchWholesales,
              handleNewValues,
              handleClean,
              searchType,
              searchWholesales,
              setOpenAvailable: handleOpenAvailable,
              isLoadingComp,
              rules,
            }}
          />
        }
      />
      <Snackbar
        open={isOpen}
        place="tr"
        message={message}
        color={color}
        closeNotification={handleCloseSnackbar}
        close
      />
      <ModalV2
        open={openAvailable}
        title="Verificar Disponibilidad"
        onClose={setOpenAvailable}
        justConfirm
      >
        <FormVerifyService
          onClose={setOpenAvailable}
          onConfirm={setOpen}
          agentCall={agentCall}
        />
      </ModalV2>
      <ModalV2
        open={open}
        title="Agregar Nuevo Cliente"
        toRight
        onClose={setOpen}
      >
        <CustomerForm
          searchInput={searchCustomers}
          onClose={setOpen}
          handlePhone
        />
      </ModalV2>
    </>
  );
};
